import { render, staticRenderFns } from "./FormRenderer.vue?vue&type=template&id=2e990ac1&"
import script from "./FormRenderer.vue?vue&type=script&setup=true&lang=ts&"
export * from "./FormRenderer.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports